import { ButtonVariant, Modal } from "@next-platform/client-common-spicy-ui";
import { useTranslation } from "@next-platform/client-common-core";
import React from "react";
import { useNavigate } from "react-router-dom";

import { ROUTES } from "@/constants";

import { INSFWSettingsModal } from "./types";

function NsfwSettingsModal({ showModal, setShowModal }: INSFWSettingsModal) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const actions = [
    {
      label: t("settings:nsfwAccess.modal.cta.cancel"),
      active: true,
      onPress: () => setShowModal(false),
      variant: ButtonVariant.TEXT,
    },
    {
      label: t("settings:nsfwAccess.modal.cta.goToProfile"),
      active: false,
      onPress: () => {
        navigate(ROUTES.profile);
      },
      variant: ButtonVariant.CONTAINED,
    },
  ];

  return (
    <Modal
      open={showModal}
      title={t("settings:nsfwAccess.modal.title")}
      description={t("settings:nsfwAccess.modal.description")}
      actions={actions}
      onOpenChange={setShowModal}
    ></Modal>
  );
}

export default NsfwSettingsModal;
